import { useFormikContext } from 'formik';
import React, { useContext } from 'react';
import { Capsule } from 'Components/frameworks/capsule/Capsule';
import { Title } from 'Components/frameworks/title/Title';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { getOrderedPaymentProviders } from 'Components/widgets/payment-info/payment-form/paymentProvidersUtils';
import { PaymentInfoContext } from 'Components/widgets/payment-info/PaymentInfoContext';
import { t } from 'Src/i18n';
import { PaymentProvidersOldImplementation } from './PaymentProvidersOldImplementation';
import { PaymentProviders } from './PaymentProviders';
type Props = {
  displayNewPaymentProvidersImplementation: boolean;
  hasFullAmount: boolean;
  isDisabled: boolean;
  title?: string;
  paymentProviders: ReadonlyArray<PaymentProvider>;
  paymentSchedule: PaymentSchedule;
  showPaymentMethodWithConditions: boolean;
  shouldAutoSubmitForm: boolean;
  onProviderSelection?: (arg0: ((arg0: string) => string) | string) => void;
};
export const PaymentProvidersForm = ({
  displayNewPaymentProvidersImplementation,
  hasFullAmount,
  isDisabled,
  paymentProviders,
  paymentSchedule,
  shouldAutoSubmitForm,
  showPaymentMethodWithConditions,
  title = 'booking.banking.paymentProvider.blockTitle',
  onProviderSelection,
}: Props) => {
  const formik = useFormikContext();
  const { isTablet } = useResponsive();
  const { isOrderedProviders, isFreeDeposit } = useContext(PaymentInfoContext);
  const { freeDeposit } = formik.values;
  let amountToPay;

  if (isFreeDeposit) {
    amountToPay = freeDeposit;
  } else {
    amountToPay = paymentSchedule.total.value;
  }

  const rePaymentSchedule = paymentSchedule.repaymentSchedules[0];
  const orderedPaymentProviders =
    !isOrderedProviders && !isTablet
      ? getOrderedPaymentProviders(
          paymentProviders,
          t('booking.banking.paymentProvider.displayOrder.mobile'),
        )
      : paymentProviders;
  return displayNewPaymentProvidersImplementation ? (
    <div className="w-full">
      <Title className="mb-10" theme="title-brand-n2">
        {t(title)}
      </Title>
      <Capsule header="none">
        <PaymentProviders
          orderedPaymentProviders={orderedPaymentProviders}
          hasFullAmount={hasFullAmount}
          rePaymentSchedule={rePaymentSchedule}
          showPaymentMethodWithConditions={showPaymentMethodWithConditions}
          shouldAutoSubmitForm={shouldAutoSubmitForm}
          paymentSchedule={paymentSchedule}
          amountToPay={amountToPay}
          isDisabled={isDisabled}
          onProviderSelection={onProviderSelection}
        />
      </Capsule>
    </div>
  ) : (
    <div className="w-full">
      <Title className="mb-10" theme="title-brand-n2">
        {t(title)}
      </Title>
      <Capsule header="none">
        <div className="flex flex-wrap">
          <PaymentProvidersOldImplementation
            orderedPaymentProviders={orderedPaymentProviders}
            isDisabled={isDisabled}
          />
        </div>
      </Capsule>
    </div>
  );
};
